import { Component, Input, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, User } from '../../../core/service/auth/auth.service';
import { TitleService } from '../../../core/service/title-service/title.service';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() federationLogoUrl: string | null = null;
  @Input() accessLevel: 'full' | 'readonly' | 'blocked' = 'readonly';
  @Output() logoutEvent = new EventEmitter<void>();

  private titleService = inject(TitleService);
  private authService = inject(AuthService);

  pageTitle = this.titleService.pageTitle;
  currentUser: User | null = null;

  get isFederationView(): boolean {
    return this.authService.isFederation();
  }

  constructor(
    private router: Router
  ) {}

  ngOnInit(): void {
    this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
  }

  logout(): void {
    this.logoutEvent.emit();
    this.authService.logout().subscribe({
      next: () => {
        this.router.navigate(['/']);
      },
      error: () => {
        this.router.navigate(['/']);
      }
    });
  }

  getBadgeColor(userType: string): string {
    const colors: { [key: string]: string } = {
      'CLUB': 'bg-blue-500',
      'LEAG': 'bg-amber-500',
      'FEDE': 'bg-emerald-500',
      'ADMI': 'bg-purple-500'
    };
    return colors[userType] || 'bg-stone-500';
  }
}
